import React from 'react';
import { WeezBeeCourseEditor } from './WeezBeeCourseEditor';

/**
 * WeezBeeCourseTemplateEditor is a wrapper component for WeezBeeCourseEditor
 * that injects the isTemplateMode prop set to true.
 * 
 * This component is used for the template editing routes under /nihol/courseTemplateEditor
 * and ensures that the editor operates in template mode.
 */
export const WeezBeeCourseTemplateEditor = (props) => {
    // Pass all props to WeezBeeCourseEditor along with isTemplateMode=true
    return <WeezBeeCourseEditor {...props} isTemplateMode={true} />;
};